<template lang="pug">
v-row(wrap).align-center
  v-col(md=8 xs=12)
    v-dialog(v-model="showSizeAlert" max-width="600")
      v-card
        .py-4.text-center
          v-icon(large).mr-2 mdi-alert
          span Максимальный размер загружаемого файла {{ MAX_SIZE }} МБ
        v-divider
        v-card-actions
          v-spacer
          v-btn(
            @click="showSizeAlert=false"
            color="warning"
            text
          ) Окей

    v-card.sdo-card
      v-card-title Сгенерировать виджет на сайт организации
      v-card-text
        p Код для вставки на сайт
        v-textarea.cursor-pointer(
          @click="copyToClipboard"
          filled
          label="Код виджета"
          readonly
          v-model="code"
          hint="Кликните для копирования"
          persistent-hint
          rows="3"
          auto-grow
          ref="widgetCode"
          :disabled="!url"
        )
        v-file-input.mt-2(
          v-model="image"
          :loading="loadingImage"
          label="Загрузить свою картинку"
          accept="image/png, image/jpeg, image/bmp"
          prepend-icon="mdi-camera"
          :hint="fileInputHint"
          persistent-hint
          @change="changeImage"
        )
        .d-flex
          v-spacer
          v-btn(
            color="success"
            rounded
            depressed
            :disabled="!url"
            :loading="loadingSave"
            @click="saveWidget"
          )
            v-icon(left) mdi-plus
            | Сохранить виджет
  v-col(md=4 xs=12 v-if="url")
    p Пример виджета
    a(
      :href="widgetUrl"
      target="_blank"
    )
      v-img(
        :src="url"
      )

</template>

<script>
import { mapGetters } from 'vuex';

import copyToClipboard from '@/utils/copy-clipboard';

import ImageUpload from '@/components/InputFields/ImageUpload.vue';

const MAX_SIZE = 2;

export default {
  name: 'CreateWidget',
  components: {
    ImageUpload,
  },
  data() {
    return {
      code: null,
      image: null,
      url: null,
      fileName: null,

      loadingImage: false,
      loadingSave: false,

      showSizeAlert: false,

      MAX_SIZE,
    };
  },
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
    }),
    widgetUrl() {
      return `${window.location.origin}/courses-all?organization=${this.userData.id}`;
    },
    fileInputHint() {
      return `Допускается загрузка файлов jpg, png, bmp до ${MAX_SIZE} МБ`;
    },
  },
  methods: {
    generate() {
      this.code = `<a href="${this.widgetUrl}" target="_blank" title="Наши курсы в СДО" style="width: 100%">
<img src="${this.url}" style="width: 100%" alt="Наши курсы в СДО"></a>`;
    },
    copyToClipboard(event) {
      const codeContainer = event.target;
      copyToClipboard(codeContainer);
      this.$toasted.info('Код виджета скопирован в буфер обмена', { duration: 5000 });
    },
    /**
     * Изменение изображения виджета
     * @param val (Object) - данные изображения url, name
     */
    async changeImage(val) {
      if (!val) return;

      const isSizeOver = val.size / 1024 / 1024 > MAX_SIZE;

      if (isSizeOver) {
        this.showSizeAlert = true;
        this.image = null;
        return;
      }
      this.loadingImage = true;
      if (val.name) {
        const formData = new FormData();
        formData.append('file', val);
        await this.$rHandler(
          this.$api.system.uploadFiles(formData),
          ({ data }) => {
            this.url = data.data.url;
            this.fileName = data.data.file_name;
            this.generate();
            return data;
          },
        );
      }
      this.loadingImage = false;
    },
    async saveWidget() {
      this.loadingSave = true;
      await this.$rHandler(
        this.$api.widgets.create({ image: this.fileName, title: this.fileName }),
        (resp) => {
          this.$emit('created');
          this.$router.push({ name: 'WidgetList' });
          return resp;
        },
      );
      this.loadingSave = false;
    },
  },
};
</script>
